import { ISelectOption } from 'components/forms/Selects'
import { IPricingTypes } from 'types/graphqlTypes'
import { SHIPPER_RATE_STATUS } from '../constants/shipperRates'

export enum RATE_TYPE_DISPLAY {
  'contract_rpm' = 'RPM',
  'contract_linehaul' = 'Linehaul',
  'contract_all_in' = 'All-in',
}

export enum RATE_TYPE {
  'RPM' = 'contract_rpm',
  'Linehaul' = 'contract_linehaul',
  'All-in' = 'contract_all_in',
  'Min Charge' = 'contract_min',
}

export enum AWARD_TYPE {
  primary = 'primary',
  backup = 'backup',
  published = 'published',
}

export enum VOLUME_TYPE {
  gross = 'gross',
  weekly = 'weekly',
  monthly = 'monthly',
  quarterly = 'quarterly',
  annual = 'annual',
}

export enum EQUIPMENT_TYPE {
  "53' Van" = '53_van',
  "53' Reefer" = '53_reefer',
  "48' Flatbed" = '48_flatbed',
}

export interface ILocation {
  postalCode?: string
  postalCode3?: string
  city?: string
  state?: string
  stateCode?: string
  isoCountryCode?: string
}

export interface IFile {
  file?: string
  fileFileName?: string
  uuid?: string
}

export interface IRate {
  id: string
  amount: string
  rateTypeKey: RATE_TYPE
  createdById: number
}

export interface IEquipment {
  id: string
  key: string
  name: string
  parentId: number
}

export interface IPricingProgram {
  id: string
  program: string
  description: string
}

export interface IAccountManager {
  id: string
  firstName: string
  lastName: string
}

export interface IShipperApplication {
  id?: string
  name?: string
  opsRep?: IAccountManager
}

export interface IActiveStatusCounts {
  all: number
  active: number
  upcoming: number
  inactive: number
}

export interface IShipperRate {
  id?: string
  shipperLaneId?: string
  rfpName?: string
  rate?: IRate
  shipperApplication?: IShipperApplication
  equipment: IEquipment
  startDate: string
  endDate?: string
  awardType: AWARD_TYPE
  pickup: ILocation
  delivery: ILocation
  shipperMiles?: string
  mapboxMiles?: number
  datMiles?: number
  minChargeRate?: IRate
  fuelRate?: IRate
  volume?: string
  volumeType?: string
  isPickupDropTrailer?: boolean
  isDeliveryDropTrailer?: boolean
  previousRates?: IShipperRate[]
  isRepricedRate: boolean
  isZonePresent: boolean
  acceptanceCapCadence?: string
  acceptanceCap?: number
  pricingType: IPricingTypes
  existingAwardId?: string
  pricingProgram?: IPricingProgram
}

export interface IEquipmentType extends ISelectOption<number> {}
export interface IAwardType extends ISelectOption<string> {}

export interface IShipperRatesFilterState {
  pickupCity?: string
  pickupStateCode?: string
  pickupPostalCode?: string
  deliveryCity?: string
  deliveryStateCode?: string
  deliveryPostalCode?: string
  awardType?: string
  equipmentId?: number
  shipperApplicationId?: number
  shipperName?: string
  shipperLaneId?: string
  shipperRateId?: number
  opsRepName?: string
  opsRepId?: string
  activeStatus?: string
  pricingProgram?: string
}

export interface IShipperRatesParams {
  pageCount: number
  perPage: number
  filters?: IShipperRatesFilterState
  sortField?: SORT_FIELD
  sortOrder?: SORT_ORDER
}

export interface IShipperRatesState {
  shipperRates: IShipperRate[]
  fetching: boolean
  error?: string
  totalCount: number
  activeStatusCounts: IActiveStatusCounts
  params: IShipperRatesParams
  activeTab: SHIPPER_RATE_STATUS
}

export interface IShipperRateModalPayload {
  rate?: IShipperRate
}

export interface IModalsState {
  showEditModal: boolean
  editModalPayload?: IShipperRateModalPayload
}

export enum SHIPPER_RATES_COLUMNS {
  id = 'Award ID',
  shipperLaneId = 'Lane ID',
  isRepricedRate = 'Repriced Rate?',
  shipper = 'Shipper',
  equipment = 'Equipment',
  startDate = 'Start Date',
  endDate = 'End Date',
  awardType = 'Award Type',
  pickupCity = 'Pickup',
  pickupZipcode = 'Pickup Zipcode',
  deliveryCity = 'Delivery',
  deliveryZipcode = 'Delivery Zipcode',
  shipperMiles = 'Shipper Miles',
  pricingProgram = 'Pricing Program',
  rate = 'Rate',
  minChargeRate = 'Min Charge',
  volume = 'Volume',
  volumeType = 'Volume Type',
  dropType = 'Drop Type',
  accountManager = 'AM',
}

export enum SORT_FIELD {
  'id' = 'ID',
  'isRepricedRate' = 'is_repriced_rate',
  'shipperLaneId' = 'shipper_lane_id',
  'equipment' = 'equipment_name',
  'startDate' = 'start_date',
  'endDate' = 'end_date',
  'awardType' = 'award_type',
  'pickupCity' = 'pickup_city',
  'pickupState' = 'pickup_state_code',
  'pickupZipcode' = 'pickup_postal_code',
  'deliveryCity' = 'delivery_city',
  'deliveryState' = 'delivery_state_code',
  'deliveryZipcode' = 'delivery_postal_code',
  'shipperMiles' = 'shipper_miles',
  'volume' = 'volume',
  'volumeType' = 'volume_type',
}

export enum SORT_ORDER {
  ASC = 'asc',
  DESC = 'desc',
}

export interface IValidation {
  pristine: boolean
  errors: { [key: string]: string }
}

export interface IBulkUploadFormState {
  file?: IFile
  email?: string
}
